export enum SearchPhase {

    SEARCH = "SEARCH",
    HIGHLIGHTS = "HIGHLIGHTS",
    AGGREGATIONS = "AGGREGATIONS"
}